import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css"
import img from "./pics/khushi.png";
const khushi = () => {
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie Reviews</a></h4>
		<h1 class="entry-title">Khushi</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.09.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 3.5</div> <div className="genre">Genre: Romance,Comedy</div>
        <p>After Arjun Reddy who is not a Deverkonda fan? His ability to bring depth and intensity to his characters is truly captivating. And if you are not a Samantha fan after Eega you probably are after watching her mesmerizing performance in the Oo Antava song. </p><br/>
<p>“Kushi" gave us a wonderful opportunity to witness the incredible chemistry between these two exceptional actors. This film is not only a heartwarming romance but also a wholesome family entertainer. It's filled with moments that will make you burst into laughter.</p><br/>
<p>Indeed, the first half of the movie takes us to the breathtaking backdrop of Kashmir, which serves as the perfect setting for a heartwarming romance. The picturesque landscapes of Kashmir, with its snow-capped mountains and serene lakes, provide a visually stunning canvas for the unfolding love story in "Kushi." </p><br/>
<p>Beyond the central love story, "Kushi" delves into the theme of contrasting beliefs in society. It beautifully illustrates how love can transcend these differences and how it has the power to mend even the most strained relationships.</p><br/>
<p> "Kushi" also highlights the significant role that family plays in the context of marriage. It emphasizes the importance of family support and involvement in a relationship's success. Furthermore, the film beautifully conveys the message that in a committed relationship, you shouldn't give up at the first sign of tension or conflict. Instead, you should be willing to fight for your partner and the relationship itself.</p><br/>
<p>Additionally, "Kushi" portrays the idea that in love, people often make sacrifices and compromises for the well-being of their partners. Sometimes, you may find yourself doing things you wouldn't typically do or going against your own beliefs just to make your partner happy and maintain harmony in the relationship. This willingness to adapt and compromise is a testament to the depth of love and commitment between the characters, making the movie even more relatable and touching for the audience</p><br/>
<p>The movie's songs are not just melodious; they're downright addictive. I've been playing "Roja Nuvve," "Aradhya," and the title track on repeat for several days now.</p><br/>
<p>I personally feel, that ”Kushi" is the type of film that lends itself beautifully to a cozy evening at home, streaming on OTT platforms. It has that relaxed, heartwarming quality that doesn't necessarily demand the grandeur of a theater setting. </p><br/>
<p><div className="highlight-texts">If you're in the mood for a light, feel-good romantic film, then "Kushi" is undoubtedly the perfect choice for you. Go ahead and watch it for a delightful cinematic experience.However, if you prefer to wait for it to become available on OTT platforms for a more relaxed viewing, that's a perfectly reasonable choice as well.
</div>
</p><br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default khushi;

 


